import {
  FormEvent,
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { sendEstimate, getEstimate } from '../api';

const QuickCalculator: FunctionComponent<{ customer: string }> = ({
  customer,
}) => {
  const [area, setArea] = useState<number>();
  const [year, setYear] = useState<number>();
  const [price, setPrice] = useState<number>();
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<undefined | string>();
  const [marketingApproval, setMarketingApproval] = useState<boolean>(false);
  const [success, setSuccess] = useState<string | undefined>();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      const linkElem = document.createElement('link');
      linkElem.setAttribute('rel', 'stylesheet');
      const link = window.location.href.includes('vercel.app')
        ? `/static/css/main.css`
        : `https://painting-frontend.vercel.app/static/css/main.css`;
      linkElem.setAttribute('href', link);
      const parents = document.getElementsByTagName('quick-calculator');
      if (parents.length) {
        parents[0]?.shadowRoot?.append(linkElem);
      }
    }
  }, []);

  const estimate = useCallback(async () => {
    if (year && area) {
      const e = await getEstimate({
        year,
        area,
      });
      setPrice(e.preliminary);
    }
  }, [area, year]);

  useEffect(() => {
    estimate();
  }, [estimate, year, area]);

  const sendForm = async (e: any) => {
    e.preventDefault();
    setError(undefined);
    if (customer && email && price) {
      const response = await sendEstimate({
        customer,
        name: `Quick Estimate: ${email}`,
        area,
        price,
        year,
        marketingApproval,
      });
      if (response.status !== 200) {
        setError(response.message || 'Det blev fel');
      } else {
        setSuccess('Tack! Din förfrågan har skickats.');
        setEmail('');
        setArea(undefined);
        setYear(undefined);
        setPrice(undefined);
        setMarketingApproval(false);
      }
    } else {
      setError('Ange en korrekt epost-adress');
    }
  };

  return (
    <div className="quickCalculator">
      <div className="quickCalculator_title">Snabboffert</div>
      <form onSubmit={sendForm} className="quickCalculator_card">
        <div className="quickCalculator_form">
          <div className="quickCalculator_specs_button_area">
            <input
              onChange={(e: FormEvent<HTMLInputElement>) =>
                setArea(parseFloat(e.currentTarget.value) || 0)
              }
              type="number"
              className="quickCalculator_specs_input_area"
              placeholder="Golvyta i m2"
            ></input>
          </div>
          <div className="quickCalculator_specs_button_year">
            <input
              onChange={(e: FormEvent<HTMLInputElement>) =>
                setYear(parseFloat(e.currentTarget.value) || 0)
              }
              type="number"
              className="quickCalculator_specs_input_year"
              placeholder="Årtal fastighet"
            ></input>
          </div>
          <div className="quickCalculator_pris">
            <label className="quickCalculator_pris_label">
              Preliminärt pris:
            </label>
            <span className="quickCalculator_pris_amount">
              {(price || '0').toLocaleString('sv-SE')}kr
            </span>
          </div>
          <div className="quickCalculator_email">
            <input
              className="quickCalculator_email_input"
              onChange={(e) => setEmail(e.currentTarget.value)}
              placeholder="Din e-post"
            ></input>
            <input
              className="quickCalculator_submit"
              type="submit"
              value="Skicka"
            ></input>
            {error && (
              <span className="quickCalculator_submit_error">{error}</span>
            )}
            {success && (
              <span className="quickCalculator_submit_success">{success}</span>
            )}
          </div>
          <div className="quickCalculator_checkbox">
            <label>
              <input
                type="checkbox"
                checked={marketingApproval}
                onChange={(e) => setMarketingApproval(e.currentTarget.checked)}
              />
              Jag godkänner reklam och villkor
            </label>
          </div>
        </div>
      </form>
    </div>
  );
};

export default QuickCalculator;
